import React from "react";
import './Footer.css';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import YouTubeIcon from '@mui/icons-material/YouTube';
import CopyrightIcon from '@mui/icons-material/Copyright';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PhoneAndroidIcon from '@mui/icons-material/PhoneAndroid';
import EmailIcon from '@mui/icons-material/Email';
import MobileSticky from "./MobileSticky";
class Footer extends React.Component {
    constructor(){
        super();
        this.state = {
            
        }
    }

    
    render() {

         return <footer id="footer" className="footer-1 footer-shadow">

                    <div className="main-footer widgets-dark typo-light">
                        <div className="container">
                            <div className="row">
                                <div className="col-xs-12 col-sm-6 col-md-4 mt-3">
                                    <div className="widget subscribe no-box">


                                        <h5 className="widget-title"><a href="/index"><img src="/assets/images/logo/footer-img.png"  alt="" width="90px" height="80px"/></a><span></span></h5>

                                        <h3 className="mb-2">Our Location</h3>
                                        <p>Trivandrum<br/>Mobile : 1800 890 2470  <br/>Email : mail@prettypets.in</p>
                                    </div>
                                </div>
                                <div className="col-xs-12 col-sm-6 col-md-4 mt-3">
                                    <div className="widget no-box">
                                        <h5 className="widget-title">Quick Links<span></span></h5>
                                        <ul className="thumbnail-widget">
                                            <li><div className="thumb-content mb-1"><a href="/home">Home</a></div></li>
                                            <br/>              

                                            <li><div className="thumb-content mb-1"><a href="/all-products">Products</a></div></li>
                                            <br/>
                                            <li><div className="thumb-content mb-1"><a href="/media">Media</a></div></li>
                                            <br/>
                                            <li><div className="thumb-content mb-1"><a href="/about-us">About Us</a></div></li>
                                            <br/>
                                            <li><div className="thumb-content mb-1"><a href="/contact-us">Contact us</a></div></li>
                                            <br/>
                                            <li><div className="thumb-content mb-1"><a href="/privacy-policy">Privacy Policy</a></div></li>
                                            <br/>
                                            <li><div className="thumb-content mb-1"><a href="/refund-policy">Refund Policy</a></div></li>
                                            <br/>
                                            <li><div className="thumb-content mb-1"><a href="/terms&conditions">Terms & conditions</a></div></li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="col-xs-12 col-sm-6 col-md-4 mt-3">
                                    <div className="widget no-box">
                                        <h5 className="widget-title">Mail To Us<span></span></h5>
                                        <p>Mail to us to know more about us or if you have any enquiries.</p>

                                        <p><a href="#" title="glorythemes" className="footer-g-mail">mail@prettypets.in</a></p>
                                        <ul className="social-footer2">
                                            <li className=""><a title="facebook" href="https://www.facebook.com/prettypets.in" target="_blank"><FacebookIcon/></a></li>
                                            <li className=""><a title="youtube" target="_blank" href="#"><YouTubeIcon/></a></li>
                                            {/*<li className=""><a href="/twitter.com" target="_blank" title="Twitter"><TwitterIcon/></a></li>*/}
                                            <li className=""><a title="instagram" target="_blank" href="https://www.instagram.com/prettypets.in/"><InstagramIcon/></a></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="footer-copyright footer-cart pb-3 pt-3 ">
                        <div className="container">
                            <div className="row">
                                <div className="col-md-12 text-center">
                                    <p><CopyrightIcon className="copy-right-icn"/> 2023 Prettypets. All rights reserved.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <MobileSticky/>
                </footer>
        }
    }
    export default Footer;